import type { FC } from 'react';
import { Button } from '@simplywallst/ui-core';
import track from 'react-tracking';
import {
  Phone,
  Bullets,
  Content,
  HelpLinks,
  SWSLogoWhite,
  PhoneWrapper,
  IntroductionBody,
  IntroductionHeader,
  SplashPanelWrapper,
  SplashPanelIntroduction,
} from './styled';

export interface SplashPanelProps {
  introducing: boolean;
}

const defaultProps = {
  introducing: true,
};

const SplashPanel: FC<SplashPanelProps & Tracking> = ({
  introducing,
  tracking: { trackEvent },
}) => {
  return (
    <SplashPanelWrapper
      as="section"
      col={12}
      colLg={7}
      introducing={introducing}
    >
      <SplashPanelIntroduction>
        <SWSLogoWhite />
        <IntroductionHeader>
          Become a more intelligent investor
        </IntroductionHeader>
        <IntroductionBody>
          <p>
            Fundamental analysis made easy on companies small &amp; big using
            premium data by S&amp;P and 30+ brokers.
          </p>
          <Button
            as="a"
            target="_blank"
            rel="noopener noreferrer"
            href="/about"
            styleType="softLink"
            onClick={() => {
              trackEvent({
                modifier: 'Learn more',
              });
            }}
          >
            Learn more
          </Button>
        </IntroductionBody>
      </SplashPanelIntroduction>
      <Content as="section" hiddenMdDown>
        <Bullets as="ul" col={6}>
          <li>Detailed fundamental analysis made easy through infographics</li>
          <li>Covering over 75,000 companies large and small in 27 markets</li>
          <li>Premium data by Standard and Poor’s and more than 30 brokers</li>
        </Bullets>
        <PhoneWrapper col={6} hiddenMdDown>
          <Phone />
        </PhoneWrapper>
      </Content>
      <HelpLinks>
        <Button
          as="a"
          target="_blank"
          href="/about"
          rel="noopener noreferrer"
          styleType="softLink"
          onClick={() => {
            trackEvent({
              modifier: 'About',
            });
          }}
        >
          About
        </Button>
        <Button
          as="a"
          target="_blank"
          href="/plans"
          rel="noopener noreferrer"
          styleType="softLink"
          onClick={() =>
            trackEvent({
              modifier: 'Plans',
            })
          }
        >
          Plans
        </Button>
        <Button
          as="a"
          target="_blank"
          href="https://support.simplywall.st/hc/en-us/articles/360000339335"
          rel="noopener noreferrer"
          styleType="softLink"
          onClick={() =>
            trackEvent({
              modifier: 'Data Sources',
            })
          }
        >
          Data Sources
        </Button>
      </HelpLinks>
    </SplashPanelWrapper>
  );
};

SplashPanel.defaultProps = defaultProps;

export default track({
  type: 'track',
  action: 'click',
})(SplashPanel);
